import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-brand-forest text-brand-bg mt-32">
      <div className="container-edit py-20 md:py-28">
        <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] text-brand-cream max-w-4xl">
          Quiet work,<br />done with rigour.
        </h2>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 text-sm leading-relaxed">
          <div className="md:col-span-5">
            <p className="font-serif text-2xl text-brand-cream mb-4">
              The Trauma-Aware Nursery Nurse
            </p>
            <p className="text-brand-bg/70 max-w-md">
              Independent parenting consultancy for protective mothers navigating
              high-conflict custody and coercive control. NNEB-trained.
              Trauma-informed. Court-safe.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="uppercase tracking-[0.25em] text-xs text-brand-bg/50 mb-5">
              Explore
            </p>
            <ul className="space-y-3">
              <li><Link to="/shop" data-testid="footer-shop" className="hover:text-brand-terracotta">Digital Library</Link></li>
              <li><Link to="/services" data-testid="footer-services" className="hover:text-brand-terracotta">1:1 Services</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="hover:text-brand-terracotta">About the Founder</Link></li>
              <li><Link to="/inquire" data-testid="footer-inquire" className="hover:text-brand-terracotta">Inquire Privately</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="uppercase tracking-[0.25em] text-xs text-brand-bg/50 mb-5">
              Methodology
            </p>
            <ul className="space-y-3 text-brand-bg/80">
              <li>Court-safe behavioural decoding</li>
              <li>The Autonomy Lab framework</li>
              <li>Generational cycle interruption</li>
              <li>NNEB early-years foundation</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-brand-bg/15 text-xs text-brand-bg/60 leading-relaxed space-y-3">
          <p data-testid="footer-safety-note">
            <strong className="text-brand-bg/90">Your safety online.</strong>{" "}
            A red <em className="not-italic">Quick Exit</em> button sits at the top of every
            page — tap it (or press <kbd className="px-1 py-0.5 bg-brand-bg/15 rounded-sm font-mono">Esc</kbd>{" "}
            twice) to leave this site immediately. You will be redirected to BBC
            Weather, the page will blank, any media will be muted, and your
            back-button history will be replaced. For deepest privacy please
            use a private / incognito browser window
            (<kbd className="px-1 py-0.5 bg-brand-bg/15 rounded-sm font-mono">Ctrl/Cmd + Shift + N</kbd>),
            and clear your browser history after visiting.
          </p>
          <p data-testid="footer-court-boundary">
            <strong className="text-brand-bg/90">A note on court attendance.</strong>{" "}
            I am an independent practitioner offering educational and
            consultative support only — I am not available, by request or by
            court order, to act as an expert witness, prepare expert reports,
            attend hearings, or give testimony in family-court proceedings.
            This boundary is informed by my own lived experience of the
            family-court system and is held with care, for the protection of
            every client. The materials and conversations I share are for your
            private observation and household practice; they are never produced
            for use as expert evidence.
          </p>
          <p data-testid="footer-disclaimer">
            <strong className="text-brand-bg/80">Safeguarding &amp; Legal Disclaimer.</strong>{" "}
            This service offers educational and consultative support only. It does
            not constitute legal, medical, or psychological advice and is not a
            substitute for advice from a qualified solicitor, GP, or mental-health
            professional. Materials are provided to support a parent's own
            observation and household practice — they must not be used to coach a
            child's testimony, nor to undermine lawful contact arrangements. If
            you or a child are in immediate danger, contact your local emergency
            services. UK readers may also contact the NSPCC on 0808 800 5000.
          </p>
          <p>© {new Date().getFullYear()} The Trauma-Aware Nursery Nurse. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
